/* Mobau Pro – Zubehörbereich der Produktseite (snippets/mobau-hersteller-zubehoer.liquid; Datei mobau-zubehoer-bereich.js), Modi „strecke“ (Biohort) und „allgemein“. 13.10.2026 */
(function () {
  var root = document.querySelector('[data-mhz]'); if (!root || root.__mhz) return; root.__mhz = true;
  var d = JSON.parse(root.querySelector('[data-mhz-daten]').textContent);
  var ALLG = d.modus === 'allgemein';
  var gewaehlt = {};   /* handle → Varianten-ID (angehakt + Ausführung bekannt) */
  var offen = {};      /* handle → true (angehakt, Ausführung fehlt noch) */
  var manuell = {};    /* handle → vom Kunden gewählte Ausführung */
  var offenStand = {}, klein = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
  var EURO = function (c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€'; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var ZUSCHNITT_TEXT = 'auf Maß geschnitten – Rückgabe und Umtausch ausgeschlossen';

  /* Allgemeiner Modus: Liste → Produkte (Reihenfolge = Priorität aus shopify_empfehlungen.py), Art je Karte aus den Gruppen */
  var reihenfolge = [], artVon = {};
  if (ALLG) {
    d.produkte = {};
    (d.liste || []).forEach(function (p) { if (!d.produkte[p.h]) { d.produkte[p.h] = p; reihenfolge.push(p.h); } });
    (d.gruppen || []).forEach(function (g) { (g.produkte || []).forEach(function (h) { if (!artVon[h]) artVon[h] = g.titel; }); });
  }
  /* Oberbereiche aus der Zubehör-Produktart (erste passende Regel; Prüfung über alle 345 Zubehörarten im Test-Shop, 13.10.2026) */
  var KATEGORIEN = [["Arbeitsschutz", "schutzbrille|brille$|maske|handschuh|jacke|hose$|mütze|stiefel|schutzhelm|warnweste|^weste|gehörschutz|schürze|knieschon"], ["Abdecken & Schützen", "abdeckfolie|abdeckband|abdeckplane|schutzvlies|malervlies|^plane|^folie|schutzhülle|kantenschutz|schutzfolie|^vlies"], ["Profile & Abschlüsse", "leiste$|leisten$|profil|schiene|fensterbank|umleimer"], ["Untergrund & Vorbereitung", "grundierung|tiefengrund|haftgrund|voranstrich|primer|haftbrücke|spachtelmasse|reparaturspachtel|fugenspachtel|abbeizer|ausgleich|ansetzmörtel|armierung|gewebe|trittschall|unterlage|dämmstreifen|dämmplatte|abdichtung|dichtschlämme|sperrbahn|schleifpapier|schleifschwamm|schleifklotz|schleifband|schleifstift|^estrich|^gips"], ["Kleben, Fugen & Dichten", "kleber|kleister|leim|mörtel|silikon|dichtstoff|dichtmasse|dichtband|dichtungsband|fugenkreuz|fugendeck|glättmittel|flussmittel|klebeband|klebepad|^paste|acryl"], ["Garten & Bewässerung", "erde$|dünger|samen|bodenverbesserer|splitt|kies|pflanz|unkraut|gießkanne|regner|tropfer|micro-drip|gartenschlauch"], ["Elektro & Anschluss", "schalter|steckdose|stecker|kabelkanal|kabeltrommel|kabelschuh|kabelverschraubung|kabelschutz|kabeldurchführung|aderendhülse|wago|^klemme|dimmer|dose|leitung|^sicherung$|bewegungsmelder|phasenprüfer|spannungsprüfer|taster|sender|antenne|fassung|leuchtmittel|schrumpfschlauch|^verlängerung"], ["Sanitär & Installation", "siphon|rohr|hahn|ventil|schlauch|brause|ablauf|armatur|übergang|kupplung|verschraubung|t-stück|bogen|muffe|dichtung|o-ring|^wc|dusch|filter|druckminderer|seifenspender|thermostat|endstück|rinne|anschluss|manschette|klemmring|stopfen|düse|aufsatz|adapter|schacht"], ["Pflege & Reinigung", "reinig|pflege|wachs|öl$|imprägn|schmier|^besen|besenkopf|handfeger|müllsack|beutel|korrosionsschutz|verdünnung|^bürste|bürstenkopf"], ["Werkzeug & Verarbeitung", "pinsel|roller|farbwalze|farbwanne|eimer|kübel|^kelle|kellen|maurerkelle|glättekelle|zahnkelle|spachtel|glätter|presse|schwamm|messer|klinge|säge|scheibe|bohrer|bits|fräser|schraubendreher|zange|hammer|feile|lineal|wasserwaage|schneider|kreide|gehrungslade|schraubstock|zwinge|meißel|senker|bohrkrone|bohrfutter|steckschlüssel|drehmoment|schere|bürste|schaber|trichter|teleskopstange|stiel|schaufel|rechen|schubkarre|kompressor|pistole|rasentrimmer|ladegerät|akku|batterie"], ["Befestigung & Montage", "schraube|dübel|anker|mutter|haken|karabiner|kabelbinder|schelle|gewindestange|befestigung|halter|montage|niete|splint|nagel|klemm|träger|bügel|draht|seil|kette|schäkel|spannschloss|winkel|gleiter|puffer|keil|scharnier|schließblech|türstopper|griff|sicherungsring|feder|stift|hülse|beschlag|verbinder|abstandshalter|kappe"], ["Farbe & Lack", "farbe|lack|lasur|beize"]]
    .map(function (k) { return { n: k[0], r: new RegExp(k[1]) }; });
  function kategorie(art) {
    var a = String(art || '').toLowerCase().trim();
    for (var i = 0; i < KATEGORIEN.length; i++) if (a && KATEGORIEN[i].r.test(a)) return KATEGORIEN[i].n;
    return 'Weiteres Zubehör';
  }
  function gruppenListe() {
    if (!ALLG) return d.struktur.gruppen || [];
    var gr = [], idx = {};
    reihenfolge.forEach(function (h) {
      var k = kategorie(artVon[h]);
      if (idx[k] === undefined) { idx[k] = gr.length; gr.push({ titel: k, produkte: [] }); }
      gr[idx[k]].produkte.push(h);
    });
    /* Gruppen nur, wenn sie gliedern: ab 2 Bereichen und 4 Karten; „Weiteres Zubehör“ steht immer zuletzt */
    if (gr.length < 2 || reihenfolge.length < 4) return [{ titel: null, produkte: reihenfolge.slice() }];
    gr.sort(function (a, b) { return (a.titel === 'Weiteres Zubehör') - (b.titel === 'Weiteres Zubehör'); });
    return gr;
  }

  function hauptVariante() {
    var inp = document.querySelector('form[action*="/cart/add"] [data-variant-id], #AddToCartForm [name="id"]');
    var id = inp ? Number(inp.value) : ((d.haupt || [])[0] || {}).id;
    if (!d.haupt) return { id: id, s: '', o: '' };
    return d.haupt.filter(function (v) { return v.id === id; })[0] || d.haupt[0];
  }
  /* Lager je Ausführung: Übach / Zentrallager (assets/mobau-zentrallager.js rechnet, sonst gleiche Regel inline) */
  function lager(v) {
    if (!v || v.inv === null || v.inv === undefined) return { uebach: null, zl: 0 };
    var Z = window.MobauZL;
    if (Z && Z.aufteilung) return Z.aufteilung(v.zl, v.inv, Date.now());
    var z = v.zl && v.zl.menge > 0 ? Math.min(Math.floor(v.zl.menge), Math.max(0, v.inv)) : 0;
    return { uebach: Math.max(0, v.inv) - z, zl: z };
  }
  /* Eine Einheit allein kaufbar? Zentrallager liefert über den Übach-Bestand hinaus nur ganze Gebinde. */
  function packSperre(v) {
    var Z = window.MobauZL; if (!ALLG || !v || !Z || !Z.packRegel) return null;
    var auf = lager(v); if (auf.uebach === null || auf.uebach >= 1) return null;
    var r = Z.packRegel(v.zl, auf);
    return r && !Z.packMengeErlaubt(r, 1) ? r : null;
  }
  function waehlbar(v) { return !!(v && v.a && !packSperre(v)); }
  /* Passende Zubehör-Ausführung.
     strecke: 1) Biohort-Zubehörpaket der Gerätehaus-Ausführung, 2) einzige Ausführung, 3) gleiche Größenbezeichnung (+ gleiche
     Farbe), 4) nur eine Ausführung in der Farbe des Gerätehauses.
     allgemein: keine Größenzuordnung – vorausgewählt nur, wenn genau eine Ausführung bestellbar ist. */
  function passend(p, hv) {
    if (ALLG) {
      var ok = p.v.filter(waehlbar);
      return { v: ok.length === 1 ? ok[0] : null, fest: false };
    }
    var skus = ((d.struktur.je_variante || {})[hv && hv.s] || []);
    var t = p.v.filter(function (v) { return skus.indexOf(v.s) >= 0; });
    if (t.length) return { v: t[0], fest: true };
    if (p.v.length === 1) return { v: p.v[0], fest: false };
    var teile = String(hv && hv.o || '').split(' / ');
    var gr = (teile[0] || '').replace(/\s*\(.*$/, '').trim(), farbe = (teile[1] || '').trim().toLowerCase();
    var farbeVon = function (v) { return String(v.o).split(' / ').map(function (x) { return x.trim(); }).filter(function (x) { return /metallic|grün|weiß|schwarz|bronze|silber/i.test(x); })[0]; };
    var g = p.v.filter(function (v) {
      var tt = String(v.o).split(' / ').map(function (x) { return x.trim(); });
      if (gr && tt.indexOf(gr) < 0) return false;
      var fa = farbeVon(v); return !fa || !farbe || fa.toLowerCase() === farbe;
    });
    if (gr && g.length === 1) return { v: g[0], fest: true };
    var f = p.v.filter(function (v) { var fa = farbeVon(v); return fa && farbe && fa.toLowerCase() === farbe; });
    if (f.length === 1) return { v: f[0], fest: true };
    return { v: null, fest: false };
  }
  function variante(h) {
    var p = d.produkte[h];
    if (manuell[h]) return p.v.filter(function (x) { return x.id === manuell[h]; })[0] || null;
    return passend(p, hauptVariante()).v;
  }
  function abPreis(p) {
    var vs = p.v.filter(function (x) { return x.a; }); if (!vs.length) vs = p.v;
    var min = Math.min.apply(null, vs.map(function (x) { return x.p; })), max = Math.max.apply(null, vs.map(function (x) { return x.p; }));
    return (min === max ? '' : 'ab ') + EURO(min);
  }
  function einheitText(v, n) { return n.toLocaleString('de-DE') + ' ' + (n === 1 ? (v.e1 || 'Stück') : (v.en || v.e1 || 'Stück')); }
  /* Lagerzeile (wie Produktkarte): grün Übach, blau Zentrallager, gelb lieferbar, grau nicht verfügbar */
  function lagerHtml(p, v) {
    var zeile = function (k, t) { return '<span class="mhz__lager"><span class="mhz__dot mhz__dot--' + k + '"></span><span>' + t + '</span></span>'; };
    if (!v) {
      var ab = p.v.filter(function (x) { return x.a; });
      if (!ab.length) return zeile('grau', 'Derzeit nicht verfügbar');
      if (ab.some(function (x) { var a = lager(x); return a.uebach > 0; })) return zeile('gruen', 'Auf Lager in Übach');
      if (ab.some(function (x) { return lager(x).zl > 0; })) return zeile('zl', 'Vorrätig im Zentrallager<span data-mbzl-ab hidden></span>');
      return zeile('amber', 'Lieferbar');
    }
    if (!v.a) return zeile('grau', 'Derzeit nicht verfügbar');
    var a = lager(v), html = '';
    if (a.uebach > 0) html += zeile('gruen', 'Auf Lager in Übach: ' + einheitText(v, a.uebach));
    if (a.zl > 0) html += zeile('zl', 'Vorrätig im Zentrallager' + (v.zl && v.zl.nur_vorraetig ? '' : ': ' + einheitText(v, a.zl)) + '<span data-mbzl-ab hidden></span>');
    return html || zeile('amber', 'Lieferbar');
  }
  function ghsHtml(p) {
    var codes = [], m, re = /GHS0?([1-9])/gi;
    while ((m = re.exec(p.gh || ''))) { if (codes.indexOf(m[1]) < 0) codes.push(m[1]); }
    if (!codes.length && !p.sw) return '';
    return '<span class="mhz__ghs">' + codes.map(function (c) { return '<img src="' + esc(String(d.ghs).replace('ghs01', 'ghs0' + c)) + '" alt="GHS0' + c + '" width="26" height="26" loading="lazy">'; }).join('') +
      (p.sw ? '<strong>' + esc(p.sw) + '</strong>' : '') + '</span>';
  }
  /* Hinweise einer Karte bzw. der Schnellansicht (allgemeiner Modus) */
  function hinweise(p, v, imModal) {
    var vv = v || p.v[0] || {}, chips = [];
    var klasse = v ? v.k : (p.v.every(function (x) { return x.k === 'abholung'; }) ? 'abholung' : '');
    if (klasse === 'abholung') chips.push('<span class="mhz__chip mhz__chip--abhol">Nur Abholung in Übach</span>');
    else if (v && v.k === 'spedition') chips.push('<span class="mhz__chip">Speditionsware</span>');
    if (vv.zs === '1') chips.push('<span class="mhz__chip">✂ Zuschnitt · keine Rückgabe</span>');
    var ps = packSperre(v);
    return lagerHtml(p, v) + (chips.length ? '<span class="mhz__chips">' + chips.join('') + '</span>' : '') +
      (ps ? '<span class="mhz__nurseite">Über den Lagerbestand hinaus nur in ganzen ' + esc(ps.labelN) + ' (' + ps.pack + ') – bitte auf der Produktseite bestellen.</span>' : '') +
      ghsHtml(p) + (p.bz ? '<p class="mhz__bz">' + esc(p.bz) + '</p>' : '');
  }
  function preisHtml(p, v) {
    if (!ALLG) return v ? EURO(v.p) : ('ab ' + EURO(Math.min.apply(null, p.v.map(function (x) { return x.p; }))));
    var basis = v ? EURO(v.p) : abPreis(p), pe = v && v.pe ? ' / ' + esc(v.pe) : '';
    var grund = v && v.up != null && v.upr ? '<span class="mhz__grund">' + EURO(v.up) + ' / ' + esc(v.upr) + '</span>' : '';
    var eek = p.ec ? (p.el ? '<a class="mhz__eek mhz__eek--' + esc(p.ec.charAt(0).toLowerCase()) + '" href="' + esc(p.el) + '" target="_blank" rel="noopener" aria-label="Energieeffizienzklasse ' + esc(p.ec) + ' – Energielabel öffnen">' + esc(p.ec) + '</a>'
      : '<span class="mhz__eek mhz__eek--' + esc(p.ec.charAt(0).toLowerCase()) + '">' + esc(p.ec) + '</span>') +
      (p.es ? ' <a class="mhz__sheet" href="' + esc(p.es) + '" target="_blank" rel="noopener">Produktdatenblatt</a>' : '') : '';
    return (eek ? '<span>' + eek + '</span>' : '') + '<span>' + basis + pe + '</span>' + grund;
  }
  function optionText(x) { return (x.o === 'Default Title' ? 'Standard' : x.o) + ' – ' + EURO(x.p) + (x.a ? (packSperre(x) ? ' (nur ganze ' + (packSperre(x).labelN) + ')' : '') : ' (nicht verfügbar)'); }
  function karte(h, hv) {
    var p = d.produkte[h], pa = passend(p, hv), v = variante(h), braucht = !v && p.v.length > 1;
    var an = !!gewaehlt[h] || !!offen[h], aus = ALLG ? (v ? !waehlbar(v) : !p.v.some(waehlbar)) : (v && !v.a);
    var meta = !ALLG && v && pa.fest && !manuell[h] ? 'Passend für ' + esc(String(hv.o).replace(/\s*\(.*?\)/, '')) + (p.v.length > 1 ? ' – ' + esc(v.o) : '') : '';
    var zeigeWahl = ALLG ? p.v.length > 1 : ((p.v.length > 1 && !(pa.fest && !manuell[h])) || manuell[h]);
    var gw = /größe|gr\./i.test(p.v.map(function (x) { return x.o; }).join(' ')) ? 'Größe' : 'Ausführung', wahlWort = ALLG ? gw : 'Ausführung';
    var wahl = zeigeWahl ?
      (braucht ? '<span class="mhz__pflicht">Bitte ' + gw + ' wählen</span>' : '') +
      '<select class="mhz__wahl" data-mhz-wahl="' + esc(h) + '" aria-label="' + wahlWort + ' für ' + esc(p.t) + '"' + (braucht ? ' aria-required="true"' : '') + '><option value="">– wählen –</option>' +
      p.v.map(function (x) { var ok = ALLG ? waehlbar(x) : x.a; return '<option value="' + x.id + '"' + (v && x.id === v.id ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + esc(ALLG ? optionText(x) : x.o + ' – ' + EURO(x.p)) + '</option>'; }).join('') + '</select>' : '';
    return '<li><div class="mhz__karte' + (gewaehlt[h] ? ' is-an' : '') + (offen[h] ? ' is-offen' : '') + (aus ? ' is-aus' : '') + '" data-mhz-karte="' + esc(h) + '">' +
      '<button type="button" class="mhz__bildknopf" data-mhz-details="' + esc(h) + '" aria-haspopup="dialog" aria-label="Details zu ' + esc(p.t) + '">' +
      (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="' + (ALLG ? 600 : 400) + '" height="' + (ALLG ? 600 : 400) + '">' : '<span class="mhz__noimg"></span>') + '</button>' +
      '<label class="mhz__wahlbox"><input type="checkbox" class="mhz__check" data-mhz-cb="' + esc(h) + '"' + (an ? ' checked' : '') + (aus ? ' disabled' : '') + '><span>' + (an ? 'Ausgewählt' : 'Dazu') + '</span></label>' +
      '<div class="mhz__body">' + (ALLG && artVon[h] ? '<span class="mhz__art">' + esc(artVon[h]) + '</span>' : '') +
      '<span class="mhz__name"><a href="' + esc(p.u) + (v ? '?variant=' + v.id : '') + '">' + esc(p.t) + '</a></span>' +
      (meta ? '<span class="mhz__meta">' + meta + '</span>' : '') + wahl +
      (offen[h] ? '<span class="mhz__hinweis" role="alert">Bitte zuerst die passende ' + wahlWort + ' wählen.</span>' : '') +
      (ALLG ? hinweise(p, v, false) : '') +
      '<div class="mhz__preiszeile"><span class="mhz__preis' + (ALLG ? ' mhz__preisbox' : '') + '">' + preisHtml(p, v) + (!ALLG && aus ? ' · derzeit nicht lieferbar' : '') + '</span>' +
      '<button type="button" class="mhz__details" data-mhz-details="' + esc(h) + '" aria-haspopup="dialog">Details</button></div></div></div></li>';
  }
  function zeichnen() {
    var hv = hauptVariante(), html = '', gi = 0;
    root.querySelectorAll('[data-mhz-g]').forEach(function (el) { offenStand[el.getAttribute('data-mhz-g')] = el.open; });
    gruppenListe().forEach(function (g) {
      var items = (g.produkte || []).filter(function (h) { return d.produkte[h]; });
      if (!items.length) return;
      if (g.titel === null) { html += '<div class="mhz__einzel"><ul class="mhz__liste" role="list">' + items.map(function (h) { return karte(h, hv); }).join('') + '</ul></div>'; return; }
      var i = gi++, auf = offenStand[i] !== undefined ? offenStand[i] : (!klein || i === 0 || items.some(function (h) { return gewaehlt[h] || offen[h]; }));
      var nAn = items.filter(function (h) { return gewaehlt[h]; }).length;
      html += '<details class="mhz__gruppe" data-mhz-g="' + i + '"' + (auf ? ' open' : '') + '><summary class="mhz__gh">' + esc(g.titel) +
        ' <span class="mhz__gn">' + items.length + (nAn ? ' · ' + nAn + ' gewählt' : '') + '</span></summary><ul class="mhz__liste" role="list">' +
        items.map(function (h) { return karte(h, hv); }).join('') + '</ul></details>';
    });
    root.querySelector('[data-mhz-gruppen]').innerHTML = html;
    summe();
  }
  function auswahl() {
    return Object.keys(gewaehlt).map(function (h) {
      var v = d.produkte[h].v.filter(function (x) { return x.id === gewaehlt[h]; })[0]; return v ? { h: h, v: v } : null;
    }).filter(Boolean);
  }
  function summe() {
    var a = auswahl(), s = a.reduce(function (t, x) { return t + x.v.p; }, 0), nOffen = Object.keys(offen).length;
    root.querySelector('[data-mhz-anzahl]').innerHTML = (a.length ? a.length + ' Zubehörteil' + (a.length === 1 ? '' : 'e') + ' ausgewählt' : 'Kein Zubehör ausgewählt') +
      (nOffen ? ' · <span class="mhz__offen">' + nOffen + ' Teil' + (nOffen === 1 ? ' braucht' : 'e brauchen') + ' noch eine Auswahl</span>' : '');
    root.querySelector('[data-mhz-summe]').textContent = a.length ? '+ ' + EURO(s) : '';
    var btn = root.querySelector('[data-mhz-add]'), txt = root.querySelector('[data-mhz-btn-text]');
    btn.classList.toggle('is-offen', !!nOffen);
    if (!txt.dataset.std) txt.dataset.std = txt.textContent;
    txt.textContent = nOffen ? 'Zur offenen Auswahl springen' : txt.dataset.std;
  }
  function zurKarte(h) {
    var k = root.querySelector('[data-mhz-karte="' + h + '"]'); if (!k) return;
    var det = k.closest('details'); if (det) det.open = true;
    k.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var sel = k.querySelector('[data-mhz-wahl]');
    if (sel) setTimeout(function () { sel.focus(); try { if (sel.showPicker) sel.showPicker(); } catch (e) {} }, 350);
  }
  function anhaken(h, an) {
    if (!an) { delete gewaehlt[h]; delete offen[h]; zeichnen(); return; }
    var v = variante(h);
    if (v && (!ALLG || waehlbar(v))) { gewaehlt[h] = v.id; delete offen[h]; zeichnen(); return; }
    offen[h] = true; zeichnen(); zurKarte(h);
  }
  root.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-mhz-cb]'), sel = e.target.closest('[data-mhz-wahl]');
    root.querySelector('[data-mhz-meldung]').textContent = '';
    if (cb) anhaken(cb.getAttribute('data-mhz-cb'), cb.checked);
    else if (sel) {
      var h = sel.getAttribute('data-mhz-wahl');
      if (sel.value) { manuell[h] = Number(sel.value); if (offen[h] || gewaehlt[h]) { gewaehlt[h] = manuell[h]; delete offen[h]; } }
      else { delete manuell[h]; delete gewaehlt[h]; }
      zeichnen();
    }
  });
  /* Schnellansicht (Modal): Daten per /products/<handle>.js, Galerie wischbar, Ausführung, Beschreibung, „Auswählen“ */
  var cacheJs = {};
  function produktJs(h) {
    if (cacheJs[h]) return Promise.resolve(cacheJs[h]);
    return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { cacheJs[h] = j; return j; }).catch(function () { return null; });
  }
  function beschreibung(html) {
    var t = document.createElement('div');
    var roh = String(html || '');
    /* Allgemein: Shop-Beschreibungen beginnen mit dem Versand-/Abhol-Textblock vor [product_description] – nur den Produkttext zeigen */
    if (ALLG && roh.indexOf('[product_description]') >= 0) roh = roh.split('[product_description]')[1].split('[/product_description]')[0];
    t.innerHTML = roh.replace(/\[\/?product_description\]/g, '');
    t.querySelectorAll('script,style,iframe').forEach(function (x) { x.remove(); });
    var erstes = t.querySelector('p'); if (erstes && /Lieferung frei Haus direkt vom Hersteller/.test(erstes.textContent)) erstes.remove();
    t.querySelectorAll('p').forEach(function (x) { if (!x.textContent.trim()) x.remove(); });
    t.querySelectorAll('a').forEach(function (a) { a.target = '_blank'; a.rel = 'noopener'; });
    return t.innerHTML;
  }
  var modalOffen = null;
  function modalZu(ausHistory) {
    if (!modalOffen) return;
    var m = modalOffen; modalOffen = null;
    m.el.remove(); document.documentElement.style.overflow = m.ov; document.documentElement.classList.remove('mhz-modal-offen'); document.removeEventListener('keydown', m.taste);
    if (!ausHistory && history.state && history.state.mhz) history.back();
    if (m.zurueck) m.zurueck.focus();
  }
  window.addEventListener('popstate', function () { if (modalOffen) modalZu(true); });
  function details(h, ausloeser) {
    var p = d.produkte[h], hv = hauptVariante(), pa = passend(p, hv), vor = variante(h);
    var el = document.createElement('div'); el.className = 'mhz-m'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'mhz-m-h');
    var wahlWort = ALLG && /größe|gr\./i.test(p.v.map(function (x) { return x.o; }).join(' ')) ? 'Größe' : 'Ausführung';
    el.innerHTML = '<div class="mhz-m__box"><div class="mhz-m__kopf"><h2 id="mhz-m-h" class="mhz-m__h">' + esc(p.t) + '</h2>' +
      '<button type="button" class="mhz-m__zu" data-mhz-m-zu aria-label="Schließen">×</button></div>' +
      '<div class="mhz-m__inhalt"><div class="mhz-m__galerie" data-mhz-m-gal>' + (p.I ? '<img src="' + esc(p.I) + '" alt="' + esc(p.t) + '">' : '') + '</div>' +
      '<div class="mhz-m__info">' + (ALLG && artVon[h] ? '<p class="mhz__art" style="margin:0 0 4px">' + esc(artVon[h]) + '</p>' : '') +
      '<p class="mhz-m__preis" data-mhz-m-preis>' + (ALLG ? '<span class="mhz__preisbox">' + preisHtml(p, vor) + '</span>' : (vor ? EURO(vor.p) : 'ab ' + EURO(Math.min.apply(null, p.v.map(function (x) { return x.p; }))))) + '</p>' +
      (!ALLG && vor && pa.fest ? '<p class="mhz-m__passend">Passend für ' + esc(String(hv.o).replace(/\s*\(.*?\)/, '')) + '</p>' : '') +
      (p.v.length > 1 ? '<label class="mhz-m__lbl" for="mhz-m-wahl">' + wahlWort + (vor ? '' : ' <span class="mhz__pflicht">Bitte wählen</span>') + '</label>' +
        '<select id="mhz-m-wahl" class="mhz__wahl" data-mhz-m-wahl><option value="">– wählen –</option>' +
        p.v.map(function (x) { var ok = ALLG ? waehlbar(x) : x.a; return '<option value="' + x.id + '"' + (vor && x.id === vor.id ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + esc(ALLG ? optionText(x) : x.o + ' – ' + EURO(x.p)) + '</option>'; }).join('') + '</select>' : '') +
      (ALLG ? '<div class="mhz-m__fakten" data-mhz-m-fakten>' + hinweise(p, vor, true) + '</div>' : '') +
      '<div class="mhz-m__text" data-mhz-m-text><p class="mhz-m__laden">Details werden geladen …</p></div>' +
      '<p><a class="mhz-m__link" href="' + esc(p.u) + '" target="_blank" rel="noopener">Zur Produktseite (neuer Tab) ↗</a></p></div></div>' +
      '<div class="mhz-m__fuss"><button type="button" class="mhz__btn" data-mhz-m-wahlen>Auswählen</button><button type="button" class="mhz-m__sek" data-mhz-m-zu>Schließen</button>' +
      '<p class="mhz-m__meldung" data-mhz-m-meldung role="status"></p></div></div>';
    var taste = function (e) {
      if (e.key === 'Escape') { e.preventDefault(); modalZu(); return; }
      if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(el.querySelectorAll('button,select,a[href],[tabindex="0"]'), function (x) { return !x.disabled && x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    };
    modalOffen = { el: el, ov: document.documentElement.style.overflow, taste: taste, zurueck: ausloeser };
    document.documentElement.style.overflow = 'hidden'; document.documentElement.classList.add('mhz-modal-offen');
    document.addEventListener('keydown', taste);
    document.body.appendChild(el);
    try { history.pushState({ mhz: 1 }, ''); } catch (e) {}
    el.querySelector('[data-mhz-m-zu]').focus();
    var wahlVar = function () { var s = el.querySelector('[data-mhz-m-wahl]'); return s && s.value ? p.v.filter(function (x) { return x.id === Number(s.value); })[0] : (s ? null : vor); };
    if (ALLG && p.v.length === 1 && !waehlbar(p.v[0])) { var wb = el.querySelector('[data-mhz-m-wahlen]'); wb.disabled = true; }
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.closest('[data-mhz-m-zu]')) { modalZu(); return; }
      if (e.target.closest('[data-mhz-m-wahlen]')) {
        var sel = el.querySelector('[data-mhz-m-wahl]'), vid = sel ? Number(sel.value) : (vor && vor.id);
        if (!vid) { sel.classList.add('is-fehlt'); sel.focus(); el.querySelector('[data-mhz-m-meldung]').textContent = 'Bitte zuerst die ' + wahlWort + ' wählen.'; return; }
        var vw = p.v.filter(function (x) { return x.id === vid; })[0];
        if (ALLG && !waehlbar(vw)) { el.querySelector('[data-mhz-m-meldung]').textContent = 'Diese ' + wahlWort + ' ist hier nicht einzeln bestellbar.'; return; }
        if (sel && (!vor || vid !== vor.id)) manuell[h] = vid;
        gewaehlt[h] = vid; delete offen[h]; modalZu(); zeichnen();
      }
    });
    el.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-mhz-m-wahl]'); if (!sel) return;
      var v = wahlVar();
      el.querySelector('[data-mhz-m-preis]').innerHTML = ALLG ? '<span class="mhz__preisbox">' + preisHtml(p, v) + '</span>' : (v ? EURO(v.p) : '');
      if (ALLG) el.querySelector('[data-mhz-m-fakten]').innerHTML = hinweise(p, v, true);
      sel.classList.remove('is-fehlt'); el.querySelector('[data-mhz-m-meldung]').textContent = '';
    });
    /* Galerie-Regel 13.10.2026: Ist eine Ausführung gewählt, nur ihr Bild + Bilder ohne Ausführungszuordnung
       (nicht die Bilder der anderen Ausführungen); ohne Auswahl alle Bilder wie bisher. */
    var zeigeBilder = function (j, vid) {
      var medien = (j.media || []).filter(function (m) { return m.media_type === 'image' && m.src; });
      var eigen = {}, va = null;
      (j.variants || []).forEach(function (x) { if (x.featured_media) eigen[x.featured_media.id] = 1; if (x.id === vid) va = x; });
      var bilder;
      if (va && va.featured_media && medien.length) {
        bilder = [va.featured_media.src || (va.featured_media.preview_image || {}).src].concat(medien.filter(function (m) { return !eigen[m.id]; }).map(function (m) { return m.src; }));
      } else bilder = medien.length ? medien.map(function (m) { return m.src; }) : (j.images || []);
      bilder = bilder.filter(Boolean).map(function (u) { return (u.indexOf('//') === 0 ? 'https:' + u : u); });
      if (!bilder.length) return;
      var g = el.querySelector('[data-mhz-m-gal]');
      g.innerHTML = bilder.map(function (u, i) {
        return '<img src="' + esc(u + (u.indexOf('?') > 0 ? '&' : '?') + 'width=1000') + '" alt="' + esc(p.t) + ' – Bild ' + (i + 1) + ' von ' + bilder.length + '" loading="' + (i ? 'lazy' : 'eager') + '">';
      }).join('');
      g.scrollLeft = 0;
      if (bilder.length > 1) g.setAttribute('tabindex', '0'); else g.removeAttribute('tabindex');
    };
    produktJs(h).then(function (j) {
      if (modalOffen === null || modalOffen.el !== el) return;
      if (!j) { el.querySelector('[data-mhz-m-text]').innerHTML = ''; return; }  /* Laden fehlgeschlagen: kein ewiges „wird geladen“ */
      var sel0 = el.querySelector('[data-mhz-m-wahl]');
      zeigeBilder(j, sel0 && sel0.value ? Number(sel0.value) : (vor && vor.id));
      el.addEventListener('change', function (e) { var s = e.target.closest('[data-mhz-m-wahl]'); if (s && s.value) zeigeBilder(j, Number(s.value)); });
      el.querySelector('[data-mhz-m-text]').innerHTML = beschreibung(j.description) || '';
    });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mhz-details]'); if (!b) return;
    details(b.getAttribute('data-mhz-details'), b);
  });
  /* Zubehörzeile für /cart/add.js: Menge 1, Einheit/Zuschnitt als Zeilen-Eigenschaft wie bei den Produktkarten */
  function zeile(x) {
    var it = { id: x.v.id, quantity: 1 }, pr = {};
    if (x.v.pel) pr.Einheit = x.v.pel;
    if (x.v.zs === '1') pr.Zuschnitt = ZUSCHNITT_TEXT;
    if (Object.keys(pr).length) it.properties = pr;
    return it;
  }
  function inDenWarenkorb(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) { if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || 'Fehler'); return x.j; });
  }
  /* Allgemein: Hauptprodukt über das Produktformular (dieselbe Logik wie „In den Warenkorb“), danach die Auswahl */
  function hauptUeberFormular() {
    return new Promise(function (ok, fehler) {
      var form = document.getElementById('AddToCartForm');
      if (!form || !form.requestSubmit) { fehler(new Error('ohne-formular')); return; }
      var fertig = false, msgEl = document.querySelector('[data-atc-msg]'), beob = null, uhr = null;
      var ende = function (erfolg, grund) {
        if (fertig) return; fertig = true;
        document.removeEventListener('cart:updated', aufUpdate); if (beob) beob.disconnect(); clearTimeout(uhr);
        if (erfolg) ok(); else fehler(new Error(grund || 'haupt'));
      };
      var aufUpdate = function () { ende(true); };
      document.addEventListener('cart:updated', aufUpdate);
      if (msgEl && window.MutationObserver) {
        beob = new MutationObserver(function () { if (msgEl.classList.contains('is-error')) setTimeout(function () { ende(false, 'haupt'); }, 50); });
        beob.observe(msgEl, { attributes: true, attributeFilter: ['class'] });
      }
      uhr = setTimeout(function () { ende(false, 'zeit'); }, 15000);
      form.requestSubmit();
    });
  }
  root.querySelector('[data-mhz-add]').addEventListener('click', function () {
    var btn = this, msg = root.querySelector('[data-mhz-meldung]'), hv = hauptVariante();
    var erstOffen = Object.keys(offen)[0];
    if (erstOffen) { zurKarte(erstOffen); return; }
    msg.textContent = '';
    if (!ALLG) {
      var mengeEl = document.querySelector('[data-qty-input]'), menge = Math.max(1, parseInt(mengeEl && mengeEl.value, 10) || 1);
      var items = [{ id: hv.id, quantity: menge }].concat(auswahl().map(function (x) { return { id: x.v.id, quantity: 1 }; }));
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || 'Fehler');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          window.location.assign('/cart');
        })
        .catch(function (e) { btn.disabled = false; msg.textContent = 'Konnte nicht in den Warenkorb legen: ' + e.message; });
      return;
    }
    var zub = auswahl().map(zeile);
    var atc = document.querySelector('[data-atc]'), hauptOk = d.haupt_verfuegbar && !(atc && atc.disabled && !atc.classList.contains('is-busy'));
    if (!hauptOk && !zub.length) { msg.textContent = 'Der Artikel ist derzeit nicht verfügbar. Wählen Sie Zubehör aus, um es einzeln in den Warenkorb zu legen.'; return; }
    btn.disabled = true;
    var schritt = hauptOk ? hauptUeberFormular() : Promise.resolve();
    schritt.then(function () { return zub.length ? inDenWarenkorb(zub) : null; }, function (e) {
      throw new Error(e.message === 'ohne-formular' ? 'Bitte legen Sie den Artikel oben in den Warenkorb.' : 'Der Artikel selbst konnte nicht in den Warenkorb gelegt werden (Hinweis oben am Mengenfeld). Ihre Zubehör-Auswahl bleibt erhalten.');
    })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:updated')); window.location.assign('/cart'); })
      .catch(function (e) { btn.disabled = false; msg.textContent = /Zubehör-Auswahl|oben/.test(e.message) ? e.message : 'Das Zubehör konnte nicht in den Warenkorb gelegt werden: ' + e.message; });
  });
  /* Allgemein: Kurzname im Sammelknopf auf ~40 Zeichen an einer Wortgrenze kürzen */
  if (ALLG) {
    var bt = root.querySelector('[data-mhz-btn-text]'), k = String(d.kurz || '');
    if (k.length > 40) { k = k.slice(0, 40).replace(/\s+\S*$/, ''); }
    bt.textContent = (d.haupt_verfuegbar ? k + ' mit Auswahl' : 'Auswahl') + ' in den Warenkorb';
    bt.dataset.std = bt.textContent;
  }
  /* Strecke: Gerätehaus-Ausführung gewechselt → passende Zubehör-Ausführung neu bestimmen (manuelle Wahl bleibt) */
  if (!ALLG) {
    var letzte = (hauptVariante() || {}).id;
    setInterval(function () {
      var jetzt = (hauptVariante() || {}).id;
      if (jetzt !== letzte) {
        letzte = jetzt;
        Object.keys(gewaehlt).concat(Object.keys(offen)).forEach(function (h) {
          var v = variante(h);
          if (v) { gewaehlt[h] = v.id; delete offen[h]; } else if (gewaehlt[h]) { delete gewaehlt[h]; offen[h] = true; }
        });
        zeichnen();
      }
    }, 400);
  }
  zeichnen();
  /* Zentrallager-Skript lädt evtl. nach dem ersten Zeichnen → Lagerzeilen einmal neu rechnen */
  if (ALLG && !window.MobauZL) window.addEventListener('load', function () { if (window.MobauZL) zeichnen(); });
})();
